import crudActions from '../../crud/actions'

const actions = crudActions('SERVICEUSER_ALLERGY_')

export default actions
